export const GET_NOT_ASSOCIATED_TAGS_AND_LOADING = "GET_NOT_ASSOCIATED_TAGS_AND_LOADING";
export const GET_ASSOCIATED_TAGS_AND_LOADING = "GET_ASSOCIATED_TAGS_AND_LOADING";
export const CREATE_NEW_TAG= "CREATE_NEW_TAG";
export const UPDATE_ASSOCIATED_TAGS_AND_LOADING = "UPDATE_ASSOCIATED_TAGS";
export const UPDATE_ASSOCIATED_TAGS_LIST = "UPDATE_ASSOCIATED_TAGS_LIST";
export const DELETE_LOCATION_TAG = "DELETE_LOCATION_TAG";
export const EDIT_LOCATION_TAG = "EDIT_LOCATION_TAG";
export const SET_TAGS_FOR_SELECTED_ITEMS = "SET_TAGS_FOR_SELECTED_ITEMS";
